import { InlineMath, BlockMath } from 'react-katex';

const LatexDecoder = (text) => {
    // Regex to match LaTeX expressions (\(...\) for inline, \[...\] for block)
    const latexRegex = /\\\((.+?)\\\)|\\\[(.+?)\\\]/g;

    // Split text into normal text and LaTeX parts
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = latexRegex.exec(text)) !== null) {
        // Add normal text before the LaTeX match
        if (match.index > lastIndex) {
            parts.push({ type: 'text', content: text.slice(lastIndex, match.index) });
        }

        // Add the matched LaTeX content
        parts.push({ type: 'latex', content: match[1] || match[2] });

        // Update lastIndex
        lastIndex = latexRegex.lastIndex;
    }

    // Add remaining normal text
    if (lastIndex < text.length) {
        parts.push({ type: 'text', content: text.slice(lastIndex) });
    }

    // Render the parts
    return parts.map((part, index) =>
        part.type === 'latex' ? (
            <InlineMath key={index}>{part.content}</InlineMath>
        ) : (
            <span key={index}>{part.content}</span>
        )
    );
}

export default LatexDecoder
